import { render, staticRenderFns } from "./WriterTypeIndicatorSkipDialog.vue?vue&type=template&id=a52fe0f0&scoped=true"
import script from "./WriterTypeIndicatorSkipDialog.vue?vue&type=script&lang=ts"
export * from "./WriterTypeIndicatorSkipDialog.vue?vue&type=script&lang=ts"
import style0 from "./WriterTypeIndicatorSkipDialog.vue?vue&type=style&index=0&id=a52fe0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fe0f0",
  null
  
)

export default component.exports